export const BAERSCREST_OPS = {
    GETTING_RECON_ENTRIES: 'GETTING_RECON_ENTRIES',
    GET_RECON_ENTRIES_SUCCESS: 'GET_RECON_ENTRIES_SUCCESS',
    GET_RECON_ENTRIES_FAILURE: 'GET_RECON_ENTRIES_FAILURE',
    GETTING_RECENT_ORDERS: 'GETTING_RECENT_ORDERS',
    GET_RECENT_ORDERS_SUCCESS: 'GET_RECENT_ORDERS_SUCCESS',
    GET_RECENT_ORDERS_FAILURE: 'GET_RECENT_ORDERS_FAILURE',
  };